import { render, staticRenderFns } from "./Begin.vue?vue&type=template&id=dd141956&"
import script from "./Begin.vue?vue&type=script&lang=js&"
export * from "./Begin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports